import { Card, CardContent } from "@/components/ui/card";
import {
  AlertTriangleIcon,
  ClockIcon,
  TrendingUpIcon,
} from "lucide-react";

type CouponsSummaryCardsProps = {
  topCode: string | null;
  lowInventory: number;
  expiringSoon: number;
  isLoading?: boolean;
};

export function CouponsSummaryCards({
  topCode,
  lowInventory,
  expiringSoon,
  isLoading,
}: CouponsSummaryCardsProps) {
  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="rounded-xl border bg-card">
            <CardContent>
              <div className="h-10 animate-pulse rounded bg-muted" />
              <div className="mt-2 h-6 w-16 animate-pulse rounded bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <Card className="rounded-xl border border-blue-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-500/10">
            <TrendingUpIcon className="size-5 text-blue-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ຄູປອງທີ່ນິຍົມ
            </p>
            <p className="font-semibold text-xl tabular-nums">
              {topCode ?? "–"}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-amber-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-amber-500/10">
            <AlertTriangleIcon className="size-5 text-amber-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ໃກ້ຈະໝົດສະຕ໋ອກ
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              {lowInventory.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-red-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-red-500/10">
            <ClockIcon className="size-5 text-red-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ໃກ້ຫມົດອາຍຸ
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              {expiringSoon.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
